import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import constants from 'src/constants';
import utils from 'src/utils';

const { UNITS } = constants.measure;
const { roundAndFormatNumber } = utils.measure;

export default class WidthAndHeight extends PureComponent {
  static propTypes = {
    width: PropTypes.number.isRequired,
    height: PropTypes.number.isRequired,
    unit: PropTypes.string,
  };

  static defaultProps = {
    unit: UNITS.feet.abbreviation,
  };

  render() {
    const { width, height, unit } = this.props;

    return (
      <div data-selenium="widthAndHeightText">
        {`${roundAndFormatNumber(width, unit)} x ${roundAndFormatNumber(
          height,
          unit,
        )}`}
      </div>
    );
  }
}
